var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoyaltyDigitalContent = function SvgIconLoyaltyDigitalContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    stroke: "#061e21",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M26.283 16.873a.83.83 0 0 1 0 .577 11 11 0 0 1-.9 1.886.833.833 0 1 1-1.429-.858 9.4 9.4 0 0 0 .654-1.317c-1.231-3.047-3.8-5-6.607-5s-5.376 1.953-6.607 5a7.76 7.76 0 0 0 5.139 4.823.833.833 0 1 1-.4 1.618 9.5 9.5 0 0 1-6.415-6.152.83.83 0 0 1 0-.577c1.427-3.878 4.678-6.378 8.283-6.378s6.856 2.5 8.282 6.378m-8.282 3.622a3.333 3.333 0 1 1 2.357-.976 3.33 3.33 0 0 1-2.357.976m1.667-3.333a1.667 1.667 0 1 0-.488 1.179 1.67 1.67 0 0 0 .488-1.179m4.756 3.578a.833.833 0 0 0-1.178 0l-1.077 1.078-1.078-1.078a.833.833 0 0 0-1.178 1.178l1.076 1.077-1.078 1.078a.833.833 0 1 0 1.178 1.178l1.078-1.078 1.077 1.078a.833.833 0 0 0 1.178-1.178l-1.076-1.078 1.078-1.078a.833.833 0 0 0 0-1.178Z"
  })));
};
export default SvgIconLoyaltyDigitalContent;